import { Inject, Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import lodashMap from 'lodash/map';
import sortBy from 'lodash/sortBy';
import { ServerApi } from './server-api';
import { extractResponseBody } from '../lib/utils';

@Injectable({ providedIn: 'root' })
export class CompanyDOTIds {
  public readonly unApprovedDotId: any = {
    carrierName: '',
    officeAddress: {
      street: '',
      city: '',
      state: '',
      zipCode: '',
    },
  };
  private _cachedList = {};

  constructor(@Inject(ServerApi) private api) {}

  public getList(id: string) {
    return this.api.get(`companies/${id}/dot_ids`)
      .pipe(
        map(extractResponseBody),
        map(res => this._updateCachedList(res)),
        map(data => this._mapList(data)),
      )
    ;
  }

  public getDOTDetails(id: string) {
    return this._cachedList[id];
  }

  private _updateCachedList(newList) {
    const cachedList = this._cachedList;
    return newList.carriers.map(dot => {
      const carrier = dot.carrier;
      return cachedList[carrier.dot_id] = {
        id: carrier.dot_id,
        carrierName: carrier.carrier_name,
        officeAddress: {
          street: carrier.carrier_street,
          city: carrier.carrier_city,
          state: carrier.carrier_state,
          zipCode: carrier.carrier_zip,
        },
      };
    });
  }

  private _mapList(list) {
    let dotNumbers = lodashMap(list, dot => {
      return {
        name: dot.id,
        value: dot.id,
      };
    });
    dotNumbers = sortBy(dotNumbers, 'name');
    return { list: dotNumbers };
  }
}
